import axios from "axios";
import { getConfigValue } from '@/core/config';

const BASE_API_URL = getConfigValue('BASE_API_URL');
const NODE_ENV = getConfigValue('NODE_ENV');

const apiV2BaseUrl = `${String(BASE_API_URL).replace('/v2', '')}/v2`;

const instance = axios.create({
    baseURL: apiV2BaseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

export default instance
